import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { GET_STARTED_URL } from '../../data/dgpt';
import { MCP_WAITLIST_PATH } from '../../data/mcp';
import { CtaButton } from '../ui/CtaButton';
import { HeroReview } from '../examples/HeroReview';
export function HomeHero() {
  const reduceMotion = useReducedMotion();
  const fadeUp = (delay = 0) => reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.55,
      delay,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
    }
  };
  return <section aria-labelledby="hero-heading" className="dgpt-dark relative overflow-hidden bg-night" data-id="element-263" data-mp="2n27kn9aiwfrg">
      <div className="dgpt-night-grid sf-fade-mask pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-264" data-mp="2s124mek88ad5" />
      <div className="relative mx-auto grid w-full max-w-[1320px] gap-12 px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-14 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-265" data-mp="3kjpjvdcjkv6b">
        <div className="flex flex-col items-start" data-id="element-266" data-mp="jwe7k0dhkb5n">
          <motion.p {...fadeUp(0)} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-night-muted" data-id="element-267" data-mp="jxpci3io3oyc">
            <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-violet" data-id="element-268" data-mp="sx2lkv2vqbij" />
            DiligenceGPT™
          </motion.p>
          <motion.h1 {...fadeUp(0.05)} id="hero-heading" className="mt-6 text-[40px] font-semibold leading-[1.02] tracking-[-0.035em] text-night-text sm:text-[60px] lg:text-[68px] xl:text-[76px]" data-id="element-269" data-mp="17knr0vn88mtm">
            AI that Masters Due Diligence:
            <br data-id="element-270" data-mp="1ckjumts0ic8n" />
            <span className="text-[#A995FF]" data-id="element-271" data-mp="1cm4mucqutj3c">Leave no stone unturned.</span>
          </motion.h1>
          <motion.p {...fadeUp(0.1)} className="mt-7 max-w-xl text-base leading-relaxed text-night-muted sm:text-lg" data-id="element-272" data-mp="3iejgupt0ymnn">
            Improve decision-making, shorten the time to a decision, and reduce due diligence costs.
          </motion.p>

          <motion.div {...fadeUp(0.15)} className="mt-9 flex w-full flex-col gap-3 sm:w-auto sm:flex-row" data-id="element-273" data-mp="1hdwsyj933jmi">
            <CtaButton href={GET_STARTED_URL} variant="violet" size="xl" event="primary_cta_click" eventParams={{
            placement: 'hero',
            cta: 'build_first_process'
          }} className="w-full sm:w-auto" data-id="element-274" data-mp="1r9q2dtriax02">
              Build Your First Process
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-275" data-mp="258poatnmwxsj" />
            </CtaButton>
            <CtaButton href={MCP_WAITLIST_PATH} variant="outlineDark" size="xl" event="mcp_waitlist_cta_click" eventParams={{
            placement: 'hero'
          }} className="w-full sm:w-auto" data-id="element-276" data-mp="29zxz9u4m4r7t">
              Join the MCP waitlist
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-277" data-mp="2o10ougutgjnh" />
            </CtaButton>
          </motion.div>
        </div>

        <motion.div {...reduceMotion ? {} : {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          duration: 0.7,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
        }
      }} className="min-w-0" data-id="element-278" data-mp="cdyiwznd6opn">
          <HeroReview data-id="element-279" data-mp="w0w6x8rjvkxi" />
        </motion.div>
      </div>
    </section>;
}